"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoFileTypeToJSON = exports.VideoFileTypeFromJSONTyped = exports.VideoFileTypeFromJSON = exports.VideoFileType = void 0;
/**
 * The file type of the video asset as defined by the 'file type' specification of the ISO base media file format standard.
 * @export
 */
exports.VideoFileType = {
    Mp4: 'MP4',
    Quicktime: 'QUICKTIME'
};
function VideoFileTypeFromJSON(json) {
    return VideoFileTypeFromJSONTyped(json, false);
}
exports.VideoFileTypeFromJSON = VideoFileTypeFromJSON;
function VideoFileTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.VideoFileTypeFromJSONTyped = VideoFileTypeFromJSONTyped;
function VideoFileTypeToJSON(value) {
    return value;
}
exports.VideoFileTypeToJSON = VideoFileTypeToJSON;
